import { withInstall } from '@zoryn/utils'
import Icon from './src/icon.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZIcon: SFCWithInstall<typeof Icon> = withInstall(Icon)
export default ZIcon

export * from './src/icon'
